<template>
    <v-app-bar elevation="0">
        <v-app-bar-title>
            <v-btn
                class="tw-border-gray-300 tw-text-dark"
                icon
                size="36"
                variant="outlined"
                @click="$router.go(-1)">
                <ArrowLeft class="tw-size-4" />
            </v-btn>
            <span
                v-if="!isNewsRoute"
                class="tw-font-title tw-text-lg tw-font-bold tw-text-dark">
                {{ pageTitle }}
            </span>
            <v-spacer></v-spacer>
            <v-btn
                v-if="isNewsRoute && canShare"
                class="tw-border-gray-300 tw-text-dark"
                icon
                size="36"
                variant="outlined"
                @click="share">
                <ShareIcon class="tw-size-4" />
            </v-btn>
        </v-app-bar-title>
    </v-app-bar>
</template>

<script setup lang="ts">
    import { Share } from '@capacitor/share';
    import ShareIcon from '@/components/icons/Share.vue';
    import ArrowLeft from '@/components/icons/ArrowLeft.vue';
    import { useAppStore } from '../store/app';
    import { useI18n } from 'vue-i18n';

    const $route = useRoute();
    const appStore = useAppStore();
    const { t } = useI18n();
    const canShare = ref(false);

    const pageTitle = computed(() => {
        // get the i18n key from the meta title of the current route
        const titleKey = $route.meta.title as string;
        return titleKey ? t(titleKey, t('App.title')) : t('App.title');
    });

    const isNewsRoute = computed(() => {
        return typeof $route.name === 'string' && ['NewsPage', 'OpinionPage'].includes($route.name);
    });

    async function share() {
        await Share.share({
            title: pageTitle.value,
            url: appStore.getOpenPostUrl,
        });
    }

    async function init() {
        canShare.value = (await Share.canShare()).value;
    }

    init();
</script>

<style lang="scss">
    .v-toolbar-title__placeholder {
        @apply tw-flex tw-flex-row tw-items-center tw-gap-4;
    }

    .v-app-bar-title {
        @apply tw-mx-5;
    }
</style>
